// extracted by mini-css-extract-plugin
export default {"inactiveText":"knd_W1kNUB6eVgv7Wymo"};